import {
  CustomerQuote,
  CustomerRequestQuotes,
  Pagination,
} from '~/composables';
import { RequestQuoteStatusMap } from '../types';

const getDate = (quote: CustomerQuote) => new Date(quote.submited_date).toLocaleDateString();
const getStatus = (quote: CustomerQuote) => RequestQuoteStatusMap[quote.status] || quote.status;
const getGrandTotal = (quote: CustomerQuote) => quote.prices.grand_total.value;
const getCurrency = (quote: CustomerQuote) => quote.prices.grand_total.currency;
const getExpirationDate = (quote: CustomerQuote) => (quote.expired_date ? new Date(quote.expired_date).toLocaleDateString() : '-');

const getPagination = (requestQuotes: CustomerRequestQuotes): Pagination => ({
  currentPage: requestQuotes?.page_info?.current_page || 1,
  totalPages: requestQuotes?.page_info?.total_pages || 1,
  totalItems: requestQuotes?.total_count || 0,
  itemsPerPage: requestQuotes?.page_info?.page_size || 10,
  pageOptions: [10, 50, 100],
});

export interface CustomerRequestQuotesGetters {
  getPagination(requestQuotes: CustomerRequestQuotes): Pagination;
  getDate(quote: CustomerQuote): string;
  getStatus(quote: CustomerQuote): string;
  getGrandTotal(quote: CustomerQuote): number;
  getCurrency(quote: CustomerQuote): string;
  getExpirationDate(quote: CustomerQuote): string;
}

const customerRequestQuotesGetters: CustomerRequestQuotesGetters = {
  getPagination,
  getDate,
  getStatus,
  getGrandTotal,
  getCurrency,
  getExpirationDate,
};

export default customerRequestQuotesGetters;
